const scrollTop = () => {
  const trigger = document.querySelector('.js-scroll');

  trigger.addEventListener('click', e => {
    const targetAnchor = document.querySelector('html');
    const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
    e.preventDefault();
    if (!targetAnchor) return;
    const originalTop = distanceToTop(targetAnchor);
    window.scrollBy({
      top: originalTop,
      left: 0,
      behavior: 'smooth',
    });
    const checkIfDone = setInterval(() => {
      const atBottom =
        window.innerHeight + window.pageYOffset >=
        document.body.offsetHeight - 2;
      if (distanceToTop(targetAnchor) === 0 || atBottom) {
        targetAnchor.tabIndex = '-1';
        targetAnchor.focus();
        clearInterval(checkIfDone);
      }
    }, 100);
  });
};
export default scrollTop;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/modules/scrollTop.js